import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTableExamDate = props => {
    const { exam_date, exam_time, loc } = props;
    return (
        <table className="prm-table prm-table-exam-date">
            <tbody>
                <tr>
                    <td className="prm-title prm-title-invert">{loc("report.exam.exam_date")}</td>
                    <td className="prm-data prm-data-invert">{exam_date}</td>
                    <td className="prm-gap"></td>
                    <td className="prm-title prm-title-invert">{loc("report.exam.exam_time")}</td>
                    <td className="prm-data prm-data-invert">{exam_time}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTableExamDate);
